import React from "react";
import theme from "@monorepo/styles/theme";
import ArrowRightOutlinedIcon from "@mui/icons-material/ArrowRightOutlined";
import { IconButton, SxProps } from "@mui/material";

interface IExpansionArrowButtonProps {
  expanded: boolean;
  onSetExpanded: () => void;
  sx?: SxProps;
}

export const ExpansionArrowButton: React.FC<IExpansionArrowButtonProps> = ({ expanded, onSetExpanded, sx }) => {
  return (
    <IconButton
      aria-label={expanded ? "shrink" : "expand"}
      sx={sx}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onSetExpanded();
      }}
    >
      <ArrowRightOutlinedIcon
        sx={{
          color: "inherit",
          transition: `all ${theme.transitions.duration.shortest / 1000}s ${theme.transitions.easing.easeInOut}`,
          transform: expanded ? "rotate(90deg)" : "rotate(0deg)",
        }}
      />
    </IconButton>
  );
};
